import { useMemo } from 'react';
import { useAppSelector } from './redux';
import {
  hasActiveMarketplaceListingAddon,
  resolveContentMasterEntitlements,
  type CmEntitlements,
} from '../utils/contentMasterEntitlements';

export function useContentMasterEntitlements(): CmEntitlements {
  const subscriptions = useAppSelector((state) => state.licenses.items);
  return useMemo(
    () => resolveContentMasterEntitlements(subscriptions),
    [subscriptions]
  );
}

/** True when the marketplace-listing add-on subscription is active. */
export function useMarketplaceListingAddonActive(): boolean {
  const subscriptions = useAppSelector((state) => state.licenses.items);
  return useMemo(
    () => hasActiveMarketplaceListingAddon(subscriptions),
    [subscriptions]
  );
}
